import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";
import { useStockControlStore } from "../../hooks/useStockControlStore";
import { useTheme } from "@mui/material";

const DialogProximo = () => {
  const { proximoDialogOpen, closeProximoDialog, resetFormulario, agregarArticuloControlado, articulo, stockReal, stockTeorico } = useStockControlStore();
  const theme = useTheme();
  const confirmarDesdeDialogo = () => {
    console.log(" DEBUG: Estado al confirmar:", {
      articulo,
      stockReal,
      stockTeorico,
    });

    if (articulo && stockReal !== null && stockTeorico !== null) {
      const nuevoArticulo = {
        idArticulo: articulo.idArticulo,
        descripcion: articulo.descripcion,
        stockReal,
        stockTeorico,
      };

      console.log(" Guardando artículo:", nuevoArticulo);
      agregarArticuloControlado(nuevoArticulo);
      resetFormulario();
      closeProximoDialog();
    } else {
      console.warn(" Faltan datos, no se guarda.");
    }
  };

  return (
    <Dialog open={proximoDialogOpen} onClose={closeProximoDialog}>
      <DialogTitle>Confirmar próximo artículo</DialogTitle>
      <DialogContent>
        <Typography>¿Deseás guardar y continuar con otro artículo?</Typography>
      </DialogContent>
      <DialogActions>
        <Button sx={{ color: "black" }} onClick={closeProximoDialog}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={confirmarDesdeDialogo} sx={{ backgroundColor: theme.bandera.colorSecundario, color: "black" }}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogProximo;
